// import { DetailsTableconstant } from "./DetailsConstant";

import { DetailsTableconstant } from "./DetailsTableConstant";

const DetailsTableAction = {};

DetailsTableAction.getDetailsTable = (payload) => {
 
    return {
        type: DetailsTableconstant.DETAILS_TABLE_SAGA,
        payload:payload
    }
};

export { DetailsTableAction };